<template>
    <el-form class="quantity-product-form">
        <div class="price-input">
            <span>What's the price per </span>
            <el-form-item class="inline-form-item">
                <el-select
                    :value="unitOfMeasurement"
                    @change="$emit('update:unitOfMeasurement', $event)"
                >
                    <el-option
                        v-for="option in $data.$uomOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                    >
                    </el-option>
                </el-select>
            </el-form-item>
            <span>of {{ productData.name }}?</span>
            <el-form-item class="inline-form-item">
                <el-input-number
                    v-model="productData.unitPrice"
                    :controls="false"
                    :precision="2"
                    placeholder="0.00"
                ></el-input-number>
            </el-form-item>
        </div>
    </el-form>
</template>

<script>
import UnitDropdownOptionsMixin from "Mixins/UnitDropdownOptionsMixin";

export default {
    mixins: [UnitDropdownOptionsMixin],
    props: {
        productData: Object,
        unitOfMeasurement: String,
        costPerUnit: String | Number,
    },
};
</script>

<style scoped lang="scss">
.inline-form-item {
    display: inline-block;
    margin: 0 8px;

    /deep/ input.el-input__inner {
        text-align: left;
    }
}
</style>
